import React, { PureComponent } from 'react';

export default class SuccessMessage extends PureComponent {

  render() {
    return (
      <div className={'k-messagebox k-messagebox-success'}>{this.props.children}</div>
    );
  }

}